import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {  ConvoloAgentsRoutes  } from "../../../routes/HomeRoutes/ConvoloAgentsRoutes";

export const ConvoloAgentsLayout = () => (
    <SwitchRoute routes={ConvoloAgentsRoutes}/>
);